module.exports = __webpack_public_path__ + "img/manage-orders.2b367478.svg";